import LocalStorageDataStorer from "../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../dataAccessLayer/localStorage/LocalStorageKey";
import JsonObjectInspector from "../validators/JsonObjectInspector";

const createNewSessionData = function(){
     const newSession = Object.freeze({
      startTime: Date.now(),
      id: Math.random().toString(36).substr(2, 9)
    });

    return newSession;
}

const getStoredSessionData = function(){
    try{
        const rawStringData = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.standardSessionDuration);
        const data = (rawStringData) ? JsonObjectInspector.safeJsonParse(rawStringData) : null;

        return data;
    }catch(err){
        //console.log("SessionService-getStoredSessionDateTime",err);
        return null;
    }
}

const saveSessionData = function(data){
    const dataString = JSON.stringify(data);
    const savedData = LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.standardSessionDuration, dataString );

    return savedData;
}

const removeSession = function(){
    const removedData = LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.standardSessionDuration);

    return removedData;    
}





const SessionService = Object.freeze({
    createNewSessionData : createNewSessionData,
    getStoredSessionData : getStoredSessionData,
    saveSessionData : saveSessionData,
    removeSession : removeSession
});

export default SessionService;